/* Site-Specific JavaScript */

jq(document).ready(function () {
    // list item marker
    jq('.etf-structure ul > li, .eq-whitepaper-list li').each(function () {
        const bullet = document.createElement('span');
        bullet.className = 'item-marker material-icons';
    
        const hasLink = this.querySelector('a') !== null;
    
        if (!hasLink) {
            bullet.setAttribute('aria-hidden', 'true');
            this.setAttribute('aria-label', this.innerText);
        }
    
        // Wrap original content in a span (no aria-hidden)
        const originalHTML = this.innerHTML;
        this.innerHTML = `<span>${originalHTML}</span>`;
    
        jq(this).prepend(bullet);
    });
    // Bootstrap select accessible clicking
    jq(document).accessibleClick(function (e) {
        const el = e.target;
        if (el.classList.contains('dropdown-toggle') || el.classList.contains('dropdown-item')) {
            el.click();
            return false;
        }
    });
    // Infinite Image Scroll
    if (jq(".infinite-slider-track").length) {
        jq(".infinite-slider-track").slick(JSON.parse(document.getElementById("infiniteSlideOptions").innerText));
        // Play/Pause of the slide track
        jq("#infinite-slider-btn").click(function () {
            if (document.getElementById('infinite-slider-btn').classList.contains('play')) {
                jq(".infinite-slider-track").slick('slickSetOption', 'autoplay', true).slick('slickPlay');
            } else {
                jq(".infinite-slider-track").slick('slickSetOption', 'autoplay', false).slick('slickPause');
            }
            document.getElementById('infinite-slider-btn').classList.toggle("play");
        });
    }
    // Image Marquee
    function initMarquees() {
        let marquees = document.querySelectorAll('.marquee-track');
        if (marquees) {
            marquees.forEach((el) => {
                let itemWidth = el.dataset.itemWidth ? parseInt(el.dataset.itemWidth) : 254; // px
                let itemGap = el.dataset.itemGap ? parseInt(el.dataset.itemGap) : 30; // px
                let scrollSpeed = el.dataset.scrollSpeed ? parseInt(el.dataset.scrollSpeed) : 50; // seconds
                let slideCount = parseInt(el.dataset.slideCount);
                let totalSlideLength = Math.round((((itemWidth + itemGap) * slideCount) + itemGap) / window.innerWidth * 100) * -1; // vw
                el.style.setProperty('--marquee-item-width', itemWidth + 'px');
                el.style.setProperty('--marquee-item-gap', itemGap + 'px');
                el.style.setProperty('--marquee-scroll-speed', scrollSpeed + 's');
                el.style.setProperty('--marquee-scroll-length', totalSlideLength + 'vw');
            });
        }
    }
    initMarquees();
    window.addEventListener("resize", (evt) => {
        initMarquees();
    });
    // Image Marquee Play/Pause Buttons
    let marqueeButtons = document.querySelectorAll('.marquee-toggle');
    if (marqueeButtons) {
        marqueeButtons.forEach((el) => {
            let target = el.dataset.target ? document.getElementById(el.dataset.target) : false;
            if (!target) {
                return;
            }
            el.addEventListener('click', (evt) => {
                // The label names the action the button performs next, which is
                // what carries the state now that aria-pressed is gone.
                if (evt.target.classList.toggle('play')) {
                    target.style.animationPlayState = 'paused';
                    el.setAttribute('aria-label', 'Play carousel of website images');
                } else {
                    target.style.animationPlayState = 'running';
                    el.setAttribute('aria-label', 'Pause carousel of website images');
                }
            });
        });
    }
    // Home Page - CTA Slider
    let homeCTASlider = jq('.homepage-cta-slider');
    let homeCTABtn = document.getElementById('homepage-cta-slider-btn');
    if (homeCTASlider.length) {
        let homeCTASliderOptions = document.getElementById('homepage-cta-slider-options');
        homeCTASliderOptions = JSON.parse(homeCTASliderOptions.innerHTML);
        homeCTASlider.slick(homeCTASliderOptions);
        // The slides hold nothing but background images, so the slideshow and
        // its dots are hidden from assistive tech and only the pause button is
        // left exposed. Slick regenerates the dots, and nothing focusable may
        // remain inside an aria-hidden subtree, so this re-runs on every redraw.
        let sliderDecor = document.querySelectorAll('#demo-carousel, .homepage-cta-wrapper .player-controls');
        if (sliderDecor.length) {
            let silenceSlider = () => {
                sliderDecor.forEach((region) => {
                    region.setAttribute('aria-hidden', 'true');
                    region.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach((node) => {
                        node.setAttribute('tabindex', '-1');
                    });
                });
            };
            silenceSlider();
            homeCTASlider.on('setPosition afterChange', silenceSlider);
        }
    }
    // Play and Pause Slider
    jq('#homepage-cta-slider-btn').accessibleClick(function () {
        if (!homeCTABtn.classList.contains("play")) {
            homeCTASlider.slick('slickPause');
            homeCTABtn.classList.add("play");
        } else {
            homeCTASlider.slick('slickPlay');
            homeCTABtn.classList.remove("play");
        }
    });
    window.onfocus = function () {
        homeCTASlider.slick('slickPlay');
    };
    window.onblur = function () {
        homeCTASlider.slick('slickPause');
    };
    // About Page - Values Slider
    let valuesSlider = jq('.values-slider');
    if (valuesSlider.length) {
        let valuesSliderOptions = document.getElementById('values-slider-options');
        valuesSliderOptions = JSON.parse(valuesSliderOptions.innerHTML);
        valuesSlider.slick(valuesSliderOptions);
    }
    // Studio Page - Works Slider
    let featuredWorksSlider = jq('.works-slider');
    if (featuredWorksSlider.length) {
        let featuredWorksSliderOptions = document.getElementById('featured-works-slider-options');
        featuredWorksSliderOptions = JSON.parse(featuredWorksSliderOptions.innerHTML);
        featuredWorksSlider.slick(featuredWorksSliderOptions);
    }


    // Custom image slider for newsroom features
    jq('.image-slider .slider-track').each(function() {
        var slider = jq(this).closest('.image-slider');
        var sliderId = slider.attr('id');
        if (!sliderId) return;
        
        // Extract ID from slider ID (e.g., "image-slider-123" -> "123")
        var idMatch = sliderId.match(/image-slider-(\d+)/);
        if (!idMatch) return;
        var id = idMatch[1];
        
        var track = jq(this);
        var slides = track.find('.slide-item');
        var sliderContent = slider.closest('.slider-content');
        var prevBtn = sliderContent.find('.slider-prev-' + id);
        var nextBtn = sliderContent.find('.slider-next-' + id);
        var dotsContainer = sliderContent.find('.slider-dots-' + id);
        var currentIndex = 0;
        var totalSlides = slides.length;
        var isTransitioning = false;
        
        if (totalSlides === 0 || prevBtn.length === 0 || nextBtn.length === 0) return;
        
        // Create dots
        function createDots() {
            dotsContainer.empty();
            for (var i = 0; i < totalSlides; i++) {
                var dot = jq('<button>')
                    .attr('type', 'button')
                    .attr('role', 'tab')
                    .attr('aria-label', 'Go to slide ' + (i + 1))
                    .attr('aria-selected', i === 0)
                    .attr('data-slide-index', i)
                    .addClass('slider-dot')
                    .on('click', function() {
                        var index = parseInt(jq(this).data('slide-index'));
                        goToSlide(index);
                    });
                dotsContainer.append(dot);
            }
        }
        
        // Update dots
        function updateDots() {
            dotsContainer.find('.slider-dot').each(function() {
                var index = parseInt(jq(this).data('slide-index'));
                jq(this).attr('aria-selected', index === currentIndex);
                jq(this).toggleClass('active', index === currentIndex);
            });
        }
        
        // Update slides - reorder to center the selected slide
        function updateSlides() {
            var windowWidth = jq(window).width();
            var showThree = windowWidth >= 968;
            
            if (showThree && totalSlides > 1) {
                // Desktop: reorder slides so center is in the middle
                var prevIndex = (currentIndex - 1 + totalSlides) % totalSlides;
                var nextIndex = (currentIndex + 1) % totalSlides;
                
                // Find slides by data-slide-index attribute
                var prevSlide = track.find('.slide-item[data-slide-index="' + prevIndex + '"]');
                var centerSlide = track.find('.slide-item[data-slide-index="' + currentIndex + '"]');
                var nextSlide = track.find('.slide-item[data-slide-index="' + nextIndex + '"]');
                
                // Remove all classes first
                track.find('.slide-item').removeClass('active center').attr('aria-hidden', 'true');
                
                // Reorder: prev, center, next
                track.empty();
                if (prevSlide.length) track.append(prevSlide);
                if (centerSlide.length) track.append(centerSlide);
                if (nextSlide.length) track.append(nextSlide);
                
                // Update classes and visibility
                if (prevSlide.length) prevSlide.addClass('active').attr('aria-hidden', 'false');
                if (centerSlide.length) centerSlide.addClass('active center').attr('aria-hidden', 'false');
                if (nextSlide.length) nextSlide.addClass('active').attr('aria-hidden', 'false');
                
                // Update slides reference after reordering
                slides = track.find('.slide-item');
            } else {
                // Mobile: show only current slide, keep all slides in original order
                // First, restore all slides to track in original order if needed
                var allSlidesArray = [];
                for (var i = 0; i < totalSlides; i++) {
                    var slide = track.find('.slide-item[data-slide-index="' + i + '"]');
                    if (slide.length) {
                        allSlidesArray.push(slide);
                    }
                }
                
                // Reorder track to original order
                if (allSlidesArray.length === totalSlides) {
                    track.empty();
                    allSlidesArray.forEach(function(slide) {
                        track.append(slide);
                    });
                }
                
                // Update visibility and classes
                slides = track.find('.slide-item');
                slides.removeClass('active center');
                slides.each(function() {
                    var slide = jq(this);
                    var slideIndex = parseInt(slide.data('slide-index'));
                    if (slideIndex === currentIndex) {
                        slide.addClass('active center').attr('aria-hidden', 'false');
                    } else {
                        slide.attr('aria-hidden', 'true');
                    }
                });
            }
            
            updateDots();
            updateAria();
        }
        
        // Update ARIA attributes
        function updateAria() {
            slides.each(function() {
                var slide = jq(this);
                var slideIndex = parseInt(slide.data('slide-index'));
                var isCurrent = slideIndex === currentIndex;
                slide.attr('aria-hidden', !isCurrent);
                slide.attr('tabindex', isCurrent ? 0 : -1);
            });
            slider.attr('aria-live', 'polite');
        }
        
        // Go to slide
        function goToSlide(index) {
            if (isTransitioning) return;
            isTransitioning = true;
            currentIndex = index;
            updateSlides();
            setTimeout(function() {
                isTransitioning = false;
            }, 500);
        }
        
        // Next slide
        function nextSlide() {
            var next = (currentIndex + 1) % totalSlides;
            goToSlide(next);
        }
        
        // Previous slide
        function prevSlide() {
            var prev = (currentIndex - 1 + totalSlides) % totalSlides;
            goToSlide(prev);
        }
        
        // Event handlers
        prevBtn.on('click', function(e) {
            e.preventDefault();
            prevSlide();
        });
        
        nextBtn.on('click', function(e) {
            e.preventDefault();
            nextSlide();
        });
        
        // Keyboard navigation
        slider.on('keydown', function(e) {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                prevSlide();
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                nextSlide();
            } else if (e.key === 'Home') {
                e.preventDefault();
                goToSlide(0);
            } else if (e.key === 'End') {
                e.preventDefault();
                goToSlide(totalSlides - 1);
            }
        });
        
        // Touch/swipe support
        var startX = 0;
        var startY = 0;
        var isDragging = false;
        
        slider.on('touchstart mousedown', function(e) {
            isDragging = true;
            startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
            startY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
        });
        
        jq(document).on('touchmove mousemove', function(e) {
            if (!isDragging) return;
            if (e.type === 'touchmove' && (!e.touches || !e.touches[0])) return;
            var currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
            var currentY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
            var diffX = startX - currentX;
            var diffY = startY - currentY;
            
            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
                if (diffX > 0) {
                    nextSlide();
                } else {
                    prevSlide();
                }
                isDragging = false;
            }
        });
        
        jq(document).on('touchend mouseup', function() {
            isDragging = false;
        });
        
        // Initialize - ensure all slides start hidden, then show the correct ones
        slides.attr('aria-hidden', 'true').removeClass('active center');
        createDots();
        updateSlides();
        
        // Responsive handling
        function handleResize() {
            updateSlides();
        }
        
        var resizeTimer;
        jq(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(handleResize, 250);
        });
    });

    // Custom Play and Pause Buttons for Videos Across Site
    jq('[data-video-wrap-id]').accessibleClick(function () {
        let video = jq(this).find('[data-video-id]');
        let playBtn = jq(this).find('[data-play-id]');
        let pauseBtn = jq(this).find('[data-pause-id]');
        let pulseBtn = jq(this).find('[data-pulse-id]');

        // When the video is first clicked - play video and show pause button
        // if clicked again, pause video and show play button
        // repeats
        if (video.get(0).paused) {
            video.trigger('play');
            playBtn.hide();
            pulseBtn.hide();
            pauseBtn.css("display", "flex");
        } else {
            video.trigger('pause');
            playBtn.css("display", "flex");
            pulseBtn.css("display", "block");
            pauseBtn.hide();
        }
    });
    // Custom Play and Pause Buttons for GIFs Across Site. Scoped to wrappers that
    // actually hold a GIF — binding every image wrapper left plain images looking
    // like unnamed clickable elements to assistive tech.
    jq('[data-image-wrap-id]').has('[data-gif-wrap-id]').accessibleClick(function () {
        let gifWrap = jq(this).find('[data-gif-wrap-id]');
        let gifBtn = jq(this).find('[data-gif-btn-id]');

        // If the image wrap contains the GIF wrap, check if
        // the GIF button has the play class
        if (jq(this).children('div[data-gif-wrap-id]').length !== 0) {
            // If no play class, add it to the btn and GIF wrap
            // Else - remove the play class from the btn and GIF wrap
            if (!gifBtn.hasClass("play")) {
                gifWrap.addClass("play");
                gifBtn.addClass("play");
            } else {
                gifWrap.removeClass("play");
                gifBtn.removeClass("play");
            }
        }
    });

    var btns = document.querySelectorAll('.video-pause-btn');
    btns.forEach(function (el) {
        // get video id from attribute 'data-target'
        var target_vid = document.getElementById(el.dataset.target);
        if (target_vid) {
            jq(el).accessibleClick(function (e) {
                if (target_vid.paused) {
                    target_vid.play();
                    el.innerHTML = 'Pause';
                } else {
                    target_vid.pause();
                    el.innerHTML = 'Play';
                }
                el.classList.toggle('paused');
            });
        }
    });

    // assign play/pause buttons to specified video
    var btns = document.querySelectorAll('.video-btn');
    btns.forEach(function (el) {
        // get video id from attribute 'data-target'
        var target_vid = document.getElementById(el.dataset.target);
        jq(el).click(function () {
            if (target_vid) {
                if (el.classList.contains('block-play-btn')) {
                    target_vid.play();
                }
                if (el.classList.contains('block-pause-btn')) {
                    target_vid.pause();
                }
            }
        });
    });

    // Finds all the boxes at the same height on the page and apply the hover class
    let boxes = document.querySelectorAll('.row-values-slider-grid .value-wrap');
    if (boxes) {
        boxes.forEach((el) => {
            el.addEventListener('mouseover', function () {
                let yPos = this.getBoundingClientRect().y;
                this.classList.add('hover');
                boxes.forEach((box) => {
                    if (yPos == box.getBoundingClientRect().y) {
                        box.classList.add('hover');
                    }
                });
            });
            el.addEventListener('mouseleave', function () {
                let yPos = this.getBoundingClientRect().y;
                this.classList.remove('hover');
                boxes.forEach((box) => {
                    if (yPos == box.getBoundingClientRect().y) {
                        box.classList.remove('hover');
                    }
                });
            });
        });
    }

    // Rotating headlines animate one option at a time, so a screen reader runs
    // the lead-in and every option together into one unreadable string. Hide the
    // animated markup and expose a single spelled-out sentence instead.
    function describeRotatingText(animated) {
        let sentence = animated.closest('.sentence') || animated.parentElement;
        if (!sentence || sentence.querySelector('.rotating-text-sr')) {
            return;
        }
        let options = Array.from(animated.children)
            .map((option) => option.textContent.replace(/\s+/g, ' ').trim())
            .filter((text) => text);
        if (!options.length) {
            return;
        }
        // The lead-in is either loose text in the sentence itself ("We've
        // perfected...") or a sibling decorative paragraph above it
        // ("Exceptionally"). Either way it has to be hidden once it has been
        // folded into the spelled-out sentence, or it gets announced twice.
        let leadNodes = Array.from(sentence.childNodes)
            .filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        let lead = leadNodes
            .map((node) => node.textContent)
            .join(' ')
            .replace(/\s+/g, ' ')
            .trim();
        if (lead) {
            // Text nodes can't carry aria-hidden, so each one gets a wrapper.
            // .rotating-text-lead is display:contents so the wrapper generates
            // no box — .sentence is a flex container and styles its direct span
            // children, which a real flex item here would wrongly inherit.
            leadNodes.forEach((node) => {
                let wrapper = document.createElement('span');
                wrapper.className = 'rotating-text-lead';
                wrapper.setAttribute('aria-hidden', 'true');
                node.parentNode.replaceChild(wrapper, node);
                wrapper.appendChild(node);
            });
        }
        let decorative = sentence.previousElementSibling;
        if (!lead && decorative && decorative.classList.contains('decorative--h2')) {
            lead = decorative.textContent.replace(/\s+/g, ' ').trim();
            decorative.setAttribute('aria-hidden', 'true');
        }
        let full = options.reduce((text, option) => {
            let clause = lead ? lead + ' ' + option : option;
            if (!text) {
                return clause;
            }
            // Options that already end a sentence don't want a comma after them
            return /[.!?]$/.test(text) ? text + ' ' + clause : text + ', ' + clause;
        }, '');

        animated.setAttribute('aria-hidden', 'true');
        let readable = document.createElement('span');
        readable.className = 'sr-only rotating-text-sr';
        readable.textContent = full;
        animated.insertAdjacentElement('afterend', readable);
    }

    // Manage animations for all rotating text
    let sentences = document.querySelectorAll('.sliding-vertical');
    let animationClass = 'fade-in-left';
    if (sentences) {
        sentences.forEach((el) => {
            describeRotatingText(el);
            let oneLoop = el.classList.contains('one-loop');
            let spans = el.querySelectorAll('span');
            let maxHeight = 0;
            spans.forEach((span, index, spanList) => {
                let height = span.getBoundingClientRect().height;
                if (maxHeight < height) {
                    maxHeight = height;
                }
                // Prevent adding animation loop if only one iteration is designated
                if (spans.length - 1 == index && oneLoop) {
                    return;
                }
                span.addEventListener('animationend', (evt) => {
                    evt.target.classList.toggle(animationClass);
                    // Use different animation for last sibling is one loop is desired
                    if (oneLoop && evt.target.nextElementSibling && !evt.target.nextElementSibling.nextElementSibling) {
                        evt.target.nextElementSibling.classList.add(animationClass + '-end');
                        return;
                    }
                    // look for next span, loop to the first one if no next sibling is available
                    let sibling = evt.target.nextElementSibling ? evt.target.nextElementSibling : spanList[0];
                    if (sibling) {
                        sibling.classList.add(animationClass);
                    }
                });
            })
            if (spans) {
                spans[0].classList.add(animationClass);
            }
            // set initial max height
            el.style.height = maxHeight + "px";
            // change the max height if window size changes
            window.addEventListener("resize", (evt) => {
                spans.forEach((span, index, spanList) => {
                    let height = span.getBoundingClientRect().height;
                    if (maxHeight != height) {
                        maxHeight = height;
                    }
                });
                el.style.height = maxHeight + "px";
            });
        });
    }
    // Animated Text pause buttons
    let pauseButtons = document.querySelectorAll('.sentence-btn');
    if (pauseButtons) {
        pauseButtons.forEach((el) => {
            let target = el.dataset.target ? document.getElementById(el.dataset.target) : false;
            if (!target) {
                return;
            }
            el.addEventListener('click', (evt) => {
                let sentence = target.querySelector('.fade-in-left');
                if (!sentence) {
                    sentence = target.querySelector('.static-text');
                }
                if (!sentence) {
                    return;
                }
                evt.target.classList.toggle('play');
                sentence.classList.toggle('fade-in-left');
                sentence.classList.toggle('static-text');
            });
        });
    }
    // Text-only nav parents are buttons so they can be reached by keyboard.
    // Opening is left to CSS — :hover / :focus-within on desktop, the .active
    // class on mobile — so the expanded state is read back off the rendered
    // submenu instead of being tracked separately in two places.
    document.querySelectorAll('button.main-nav-text[aria-controls]').forEach((button) => {
        let item = button.closest('li');
        let submenu = document.getElementById(button.getAttribute('aria-controls'));
        if (!item || !submenu) {
            return;
        }
        let sync = () => window.requestAnimationFrame(() => {
            let open = submenu.getBoundingClientRect().height > 0;
            button.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        ['mouseenter', 'mouseleave', 'focusin', 'focusout', 'click'].forEach((name) => {
            item.addEventListener(name, sync);
        });
        // Escape closes the dropdown and puts focus back on its button. Focus
        // staying inside the item would keep :focus-within open, so the shut
        // state is held by a class until something asks for the menu again.
        let reopen = () => {
            if (item.classList.contains('nav-force-closed')) {
                item.classList.remove('nav-force-closed');
                sync();
            }
        };
        item.addEventListener('keydown', (evt) => {
            if (evt.key === 'Escape' || evt.key === 'Esc') {
                item.classList.add('nav-force-closed');
                button.focus();
                sync();
                return;
            }
            // Any deliberate re-open gesture on the button itself
            if (evt.target === button && (evt.key === 'Enter' || evt.key === ' ' || evt.key === 'ArrowDown')) {
                reopen();
            }
        });
        item.addEventListener('mouseenter', reopen);
        item.addEventListener('click', reopen);
        item.addEventListener('focusout', (evt) => {
            if (!item.contains(evt.relatedTarget)) {
                reopen();
            }
        });
    });
    // Slick slider arrow buttons - remove aria-disabled
    let sliderArrows = document.querySelectorAll('.slick-arrow');
    if (sliderArrows) {
        sliderArrows.forEach((el) => {
            el.removeAttribute('aria-disabled');
        });
    }
    // Slick slider pause buttons
    let sliderPauseButtons = document.querySelectorAll('.slider-pause-btn');
    if (sliderPauseButtons) {
        sliderPauseButtons.forEach((el) => {
            let target = el.dataset.target ? el.dataset.target : false;
            if (!target) {
                return;
            }
            el.addEventListener('click', (evt) => {
                if (evt.target.classList.toggle('play')) {
                    jq('#' + target).slick('slickPause');
                    el.setAttribute('aria-label', 'Play Slideshow');
                } else {
                    jq('#' + target).slick('slickPlay');
                    el.setAttribute('aria-label', 'Pause Slideshow');
                }
            });
        });
    }
    // ABLEPLAYER forcing remove fullscreen class when pressing ESC or clicking fullscreen handler button
    jq(document).on('fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange', function () {
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
            jq('.able-wrapper').removeClass('fullscreen');
            setTimeout(function () {
                jq('.able-wrapper').removeClass('fullscreen');
                jq('.able-player.able-video').addClass('smallplayer');
                jq('.able-captions-wrapper').removeClass('able-captions-overlay');
                jq('.able-captions-wrapper').addClass('able-captions-below');
            }, 100);
            setTimeout(function () {
                if (jq('.able-button-handler-fullscreen').attr('aria-label') === 'Exit full screen') {
                    jq('.able-button-handler-fullscreen').trigger('click');
                }
            }, 200);
        } else {
            jq('.able-player.able-video').removeClass('smallplayer');
        }
    });
    // ABLE PLAYER COLLAPSE TRANSCRIPTS
    jq('.transcript-trigger').click(function () {
        jq('#transcript').toggleClass('show');
        jq(this).toggleClass('open');
        if (jq(this).hasClass('open')) {
            jq(this).find('span').html('Hide');
        } else {
            jq(this).find('span').html('Show');
        }
    });

    // Video hover functionality for IR Webiste Templates Snippet
    const hoverVideos = document.querySelectorAll('.video-wrapper:not(.ableplayer-video-wrapper)');
    hoverVideos.forEach((ele) => {
        let video = ele.querySelector('.video-content video');
        let videoContent = ele.querySelector(".video-content");

        // Check if the video and videoContent elements exist before adding event listeners
        if (video && videoContent) {
            ele.addEventListener('mouseover', () => {
                videoContent.classList.add("fade-in");
                videoContent.classList.remove("fade-out");
                videoContent.style.display = 'block';
                setTimeout(() => {
                    video.play();
                }, 300);
            });

            ele.addEventListener('mouseleave', () => {
                videoContent.classList.remove("fade-in");
                videoContent.classList.add("fade-out");
                setTimeout(() => {
                    videoContent.style.display = 'none';
                    video.pause();
                }, 250);
            });

            video.addEventListener('ended', () => {
                video.currentTime = 0;
                video.play();
            });
        }
    });
    function adjustElementHeights() {
        var screenWidth = jq(window).width();
        if (screenWidth >= 992) {
            var maxHeight = 0;
            // Find the maximum height among elements with data-mh="list"
            jq('[data-height="list"]').each(function () {
                var elementHeight = jq(this).height();
                if (elementHeight > maxHeight) {
                    maxHeight = elementHeight;
                }
            });
            // Set the maximum height to all elements with data-mh="list"
            jq('[data-height="list"]').height(maxHeight);
        } else {
            // Reset the height to auto when the screen size is less than 992px
            jq('[data-height="list"]').css('height', 'auto');
        }
    }
    // Initial adjustment on page load
    adjustElementHeights();
    // Adjust heights on window resize
    jq(window).resize(function () {
        adjustElementHeights();
    });
    // add aria-hidden to all images without alt-text
    let page_images = document.querySelectorAll('img:not([alt]), img[alt=""]');
    if (page_images) {
        page_images.forEach((el) => {
            el.setAttribute('aria-hidden', 'true');
        });
    }
    // Website Data and Policy Form Validation
    var validator = jq(".validate-data-and-policy-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr('id');
        jq(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                    messages: {
                        equalTo: "Passwords must be the same"
                    }
                }
            },
            errorPlacement: function (error, element) {
                if (element.attr("type") === "radio") {
                    error.prependTo(element.closest('.radio-button-group'));
                } else {
                    error.appendTo(element.parent());
                }
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            },
            invalidHandler: function (event, validator) {
                // Scroll to the first element with the error class and focus on the input field
                scrollToFirstError(validator);
            }
        });

        // Handles Enter key event for the Submit button
        $form.on('keydown', function (event) {
            var focusedElement = jq(document.activeElement);

            // Prevent form submit event if the focused item is a download-link
            if (event.which === 13 && !focusedElement.hasClass('download-link')) {
                if ($form.valid()) {
                    scrollToFirstError(jq.validator);
                }
            }
        });
        // Makes sure the screen is scrolled to the first error and resets focus
        function scrollToFirstError(validator) {
            var firstError = validator.errorList[0];
            if (firstError) {
                var firstErrorElement = jq(firstError.element);
                jq('html, body').animate({
                    scrollTop: firstErrorElement.offset().top - 120
                }, 500, function () {
                    firstErrorElement.focus();
                });
            }
        }
    });
    // Data Collection and Privacy Form conditionals 
    if (jq(".data-collection-and-privacy-form").length) {
        // CCPA 
        jq('input[name="subject_to_CCPA"]').on('change', function () {
            const ccpaYes = '[data-show-hide="subject_to_CCPA_yes"]';

            // Uncheck radio button(s) when hidden
            uncheckRadioButtons(ccpaYes);

            if (jq(this).attr('id') != 'subject_to_CCPA_yes') {
                jq(ccpaYes).addClass('d-none');
            } else {
                jq(ccpaYes).removeClass('d-none');
            }
        });
        // GDPR
        jq('input[name="subject_to_GDPR"]').on('change', function () {
            const ccpaYes = '[data-show-hide="subject_to_GDPR_yes"]';
            const ccpaNo = '[data-show-hide="subject_to_GDPR_no"]';
            const solution = '[data-show-hide="solution"]';

            // Uncheck radio button(s) when hidden
            uncheckRadioButtons(ccpaNo);
            uncheckRadioButtons(ccpaYes);
            uncheckRadioButtons(solution);

            if (jq(this).attr('id') != 'subject_to_GDPR_yes') {
                jq(ccpaYes).addClass('d-none');
                jq(solution).addClass('d-none');
            } else {
                jq(ccpaYes).removeClass('d-none');
                jq(solution).removeClass('d-none');
                checkRadioButton(ccpaYes);
            }
            if (jq(this).attr('id') != 'subject_to_GDPR_no') {
                jq(ccpaNo).addClass('d-none');
            } else {
                jq(ccpaNo).removeClass('d-none');
            }
        });
        // GDPR = No and No Banner option selected
        jq('input[name="cookie_approach"]').on('change', function () {
            const solution = '[data-show-hide="solution"]';
            const handleCookies = '[data-show-hide="handle_cookies"]';

            // Uncheck radio button(s) when hidden
            uncheckRadioButtons(solution);
            uncheckRadioButtons(handleCookies);

            if (jq(this).attr('id') != 'no_banner') {
                jq(solution).removeClass('d-none');
                jq(handleCookies).addClass('d-none');
            } else {
                jq(solution).addClass('d-none');
                jq(handleCookies).addClass('d-none');
            }
        });
        // Privacy Policy 
        jq('input[name="privacy_policy"]').on('change', function () {
            const provide = '[data-show-hide="provide_privacy_policy_document"]';

            // Uncheck radio button(s) when hidden
            uncheckRadioButtons(provide);

            if (jq(this).attr('id') != 'provide_privacy_policy_document') {
                jq(provide).addClass('d-none');
            } else {
                jq(provide).removeClass('d-none');
            }
        });
        // Google Analytics / GTM
        jq('input[name="google_analytics"]').on('change', function () {
            const gaGtmIds = '[data-show-hide="google_analytics_yes"]';

            clearFormInputs(gaGtmIds);

            if (jq(this).attr('id') != 'google_analytics_yes') {
                jq(gaGtmIds).addClass('d-none');
            } else {
                jq(gaGtmIds).removeClass('d-none');
            }
        });
        // Cookie Vender
        jq('input[name="cookie_vendor"]').on('change', function () {
            const existing = '[data-show-hide="cookie_vendor_existing"]';
            const eqProvided = '[data-show-hide="handle_cookies"]';

            // Uncheck radio button(s) when hidden
            uncheckRadioButtons(eqProvided);
            clearFormInputs(existing);

            if (jq(this).attr('id') != 'cookie_vendor_existing') {
                jq(existing).addClass('d-none');
            } else {
                jq(existing).removeClass('d-none');
            }

            if (jq(this).attr('id') != 'cookie_vendor_provided') {
                jq(eqProvided).addClass('d-none');
            } else {
                jq(eqProvided).removeClass('d-none');
            }
        });
        function uncheckRadioButtons(selector) {
            jq(selector + ' input[type="radio"]').prop('checked', false);
        }
        function checkRadioButton(selector) {
            jq(selector + ' input[type="radio"]').prop('checked', true);
        }
        function clearFormInputs(selector) {
            jq(selector + ' input[type="text"]').val('');
            jq(selector + ' input[type="email"]').val('');
        }
    }

    // Wait for #map to have content, then set aria-hidden on all images
    observeForContent('.row-contact-map .map-wrapper #map').then(() => {
        jq('.row-contact-map .map-wrapper #map img').each(function () {
            if (!jq(this).hasClass('leaflet-marker-icon')) {
                jq(this).attr('aria-hidden', 'true');
            } else {
                jq(this).removeAttr('role'); // Remove role from leaflet marker images
            }
        });
        jq('.leaflet-marker-icon').attr('aria-hidden', 'true');
        jq('.leaflet-marker-icon').attr('tabindex', '-1');
        jq('#map').attr('tabindex', '-1');
        document.querySelectorAll('.leaflet-control-attribution a').forEach(link => {
            const span = document.createElement('span');
            span.innerHTML = link.innerHTML;
            span.className = link.className; // preserve classes
            span.setAttribute('aria-hidden', 'true'); // optional: hide from assistive tech
            link.replaceWith(span);
        });
    });


    // remove empty IDs created by slick slider on 'homepage-cta-slider'
    jq('div.homepage-cta-wrapper *').each(function () {
        if (jq(this).attr('id') === '') {
            jq(this).removeAttr('id');
        }
    });
});

function observeForContent(selector) {
    return new Promise((resolve, reject) => {
        let checkInterval = setInterval(() => {
            if (jq(selector).html()) {
                clearInterval(checkInterval);
                resolve();
            }
        }, 100); // Check every 100 milliseconds
    });
}

function updateMatchedHeights() {
    const groups = {};

    // Collect elements into groups based on data-mh attribute
    document.querySelectorAll('[data-mh]').forEach(el => {
        const groupName = el.getAttribute('data-mh');

        if (!groups[groupName]) {
            groups[groupName] = [];
        }

        groups[groupName].push(el);
    });

    // Reset heights before recalculating
    Object.values(groups).forEach(group => {
        group.forEach(el => el.style.height = 'auto');
    });

    // Find the tallest element in each group and apply that height to all members
    Object.values(groups).forEach(group => {
        const maxHeight = Math.max(...group.map(el => el.offsetHeight));
        group.forEach(el => el.style.height = `${maxHeight}px`);
    });

}

// Run on load and resize
window.addEventListener('load', updateMatchedHeights);
window.addEventListener('resize', updateMatchedHeights);

// Brand Visibility line art canvas
(function () {
    function init() {
        var heading = document.querySelector('.module.row-section-heading');
        if (!heading) return;
        var aeo = heading.previousElementSibling;
        var analytics = heading.nextElementSibling;
        var monitoring = analytics && analytics.nextElementSibling;
        if (!aeo || !aeo.classList.contains('row-ai-included')) return;
        if (!analytics || !analytics.classList.contains('row-website-analytics')) return;
        if (!monitoring || !monitoring.classList.contains('row-brand-monitoring')) return;
        function size() {
            var top = heading.getBoundingClientRect().top;
            var bottom = monitoring.getBoundingClientRect().bottom;
            heading.style.setProperty('--bv-aeo-h', aeo.getBoundingClientRect().height + 'px');
            heading.style.setProperty('--bv-h', (bottom - top) + 'px');
            heading.classList.add('bv-canvas');
        }
        size();
        if (window.ResizeObserver) {
            var ro = new ResizeObserver(size);
            [aeo, heading, analytics, monitoring].forEach(function (el) { ro.observe(el); });
        } else {
            window.addEventListener('resize', size);
        }
        window.addEventListener('load', size);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
